module.exports = __webpack_public_path__ + "static/img/ottawa2.ada759b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/ottawa2.jpg
// module id = 118
// module chunks = 9